import { render, staticRenderFns } from "./DInput.vue?vue&type=template&id=52cd9504&scoped=true&"
import script from "./DInput.vue?vue&type=script&lang=js&"
export * from "./DInput.vue?vue&type=script&lang=js&"
import style0 from "./DInput.vue?vue&type=style&index=0&id=52cd9504&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52cd9504",
  null
  
)

export default component.exports